import { render, staticRenderFns } from "./FormPresentationDescriptiveText.vue?vue&type=template&id=796b375a&"
import script from "./FormPresentationDescriptiveText.vue?vue&type=script&lang=js&"
export * from "./FormPresentationDescriptiveText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports